import React, { useState, useEffect, useRef, useContext } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { DataContext } from "./DataContext";

const SleepScreen = ({ activateIdleTimer }) => {
  const { globalData } = useContext(DataContext);
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const timerRef = useRef(null);

  const tappable_image = globalData.acf.s_image_1;
  const image1 = globalData.acf.sleep_screen_image_1;
  const image2 = globalData.acf.sleep_screen_image_2;
  const image3 = globalData.acf.sleep_screen_image_3;
  const image4 = globalData.acf.sleep_screen_image_4;

  useEffect(() => {
    setImages([
      { url: tappable_image, type: "tappable_image" },
      { url: image1, type: "image" },
      { url: tappable_image, type: "tappable_image" },
      { url: image2, type: "image" },
      { url: tappable_image, type: "tappable_image" },
      { url: image3, type: "image" },
      { url: tappable_image, type: "tappable_image" },
      { url: image4, type: "image" },
    ]);
  }, [image1, image2, image3, image4, tappable_image]);

  // Cycle through images
  useEffect(() => {
    if (images.length === 0) return;

    timerRef.current = setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 10000);

    return () => clearTimeout(timerRef.current);
  }, [currentIndex, images]);

  // Handle image clicks
  const handleImageClick = (imageType) => {
    // if (imageType === "tappable_image") {
    activateIdleTimer(); // Reactivate IdleTimerProvider
    navigate("/"); // Navigate to Home
    // }
  };

  return (
    <motion.div
      className="splash-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      onClick={() => handleImageClick(images[currentIndex]?.type)}
      onTouchStart={() => handleImageClick(images[currentIndex]?.type)}
    >
      {images.length > 0 && (
        <img
          src={images[currentIndex]?.url}
          alt={`Splash Screen ${currentIndex + 1}`}
          className="splash-image"
        />
      )}
    </motion.div>
  );
};

export default SleepScreen;
